<template>
  <div class="sample-expression-scatter">
    <d3-chart v-show="!error_message"
                :options="scatterChartOptions"
                class="mt-8"></d3-chart>
    <v-alert v-show="error_message"
             class="mt-8">{{error_message}}</v-alert>
  </div>
</template>

<script>
export default {
  name: 'SampleExpressionScatter',
  props: {
    scatterData: {
      type: Array,
      default() {
        return []
      }
    },
    pValue: {
      type: Array,
      default() {
        return null
      }
    },
    rValue: {
      type: Array,
      default() {
        return null
      }
    },
    errorMessage: {
      type: Array,
      default() {
        return null
      }
    }
  },
  data() {
    return {
      scatter_data: [],
      pvalue: null,
      rvalue: null,
      error_message: null,
      scatterChartOptions: {
        chart: {
          type: 'scatter',
          zoomType: 'xy'
        },
        title: {
          text: null
        },
        subtitle: {
          text: '',
          style: {
            'font-family': '"Roboto", sans-serif',
            'font-size': 15,
            'font-weight': 'bold',
          }
        },
        credits: {
          enabled: false
        },
        xAxis: {
          title: {
            enabled: true,
            text: 'Expression Value (log2(tpm+0.001))',
            style: {
              'font-family': '"Roboto", sans-serif',
              'font-size': 12,
              'font-weight': 'bold',
            }
          },
          startOnTick: true,
          endOnTick: true,
          showLastLabel: true
        },
        yAxis: {
          min: 0,
          max: 1,
          title: {
            text: 'PSI Value',
            style: {
              'font-family': '"Roboto", sans-serif',
              'font-size': 12,
              'font-weight': 'bold',
            }
          }
        },
        legend: {
          layout: 'horizontal',
          align: 'left',
          verticalAlign: 'bottom',
          x: 30,
          y: 10,
          floating: true,
          backgroundColor: '#fff',
          borderWidth: 1,
          style: {
            'font-family': 'Arial',
            'font-size': 15,
            'font-weight': 'bold',
          }
        },
        plotOptions: {
          scatter: {
            marker: {
              radius: 5,
              states: {
                hover: {
                  enabled: true,
                  lineColor: 'rgb(100,100,100)'
                }
              }
            },
            states: {
              hover: {
                marker: {
                  enabled: false
                }
              }
            },
            tooltip: {
              headerFormat: '<b>{series.name}</b><br>',
              pointFormat: '<b>Exp: </b>{point.x}<br/><b>PSI: </b>{point.y}',
            }
          }
        },
        series: [{
          name: 'Tumor',
          color: 'rgba(223, 83, 83, .8)',
          data: []

        }, {
          name: 'Normal',
          color: 'rgba(119, 152, 191, .8)',
          data: []
        }]
      }
    }
  },
  watch: {
    scatterData(newVal, oldVal) {
      // console.log(oldVal, newVal);
      if (newVal.length > 0) {
        this.scatter_data = newVal;
        this.error_message = null; // 刷新
        setTimeout(() => {
          this.initExpressScatterPlot();
        }, 200);
      }
    },
    pValue(val) {
      // console.log(val);
      this.pvalue = val[0];
      // console.log(this.pvalue);
    },
    rValue(val) {
      // console.log(val);
      this.rvalue = val[0];
      // console.log(this.rvalue);
    },
    errorMessage(val) {
      // console.log(val);
      this.error_message = val[0];
    }
  },
  methods: {
    initExpressScatterPlot() {
      let scatterdata = this.scatter_data;
      let pvalue = this.pvalue;
      let rvalue = this.rvalue;
      // console.log(scatterdata);
      let tumor_data = [];
      let normal_data = [];
      scatterdata && scatterdata.forEach((v, i, a) => {
        if (v.type == "Tumor") {
          tumor_data.push([v.exp, v.psi])
        } else if (v.type == "Normal") {
          normal_data.push([v.exp, v.psi])
        }
      });
      this.scatterChartOptions.series[0].data = tumor_data;
      this.scatterChartOptions.series[1].data = normal_data;
      this.scatterChartOptions.subtitle.text = "r = " + rvalue + "&nbsp;&nbsp;&nbsp;" + "p = " + pvalue;
    },
  },
}
</script>
<style scoped>
</style>
